'use client' 

import ErrorDisplay from '@/components/ErrorDisplay';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react'
 
export default function Error({ error, reset }) {
  const router = useRouter();
  const [errorMessage, setErrorMessage] = useState("An unknown error occurred.");
  const [statusCode, setStatusCode] = useState(500);
  const [isResetting, setIsResetting] = useState(false);
  useEffect(() => {
    if (error) {
      setErrorMessage(error.message || "An unexpected error occurred.");
      setStatusCode(error.status || 500);
      if (error.message.includes("404") || error.status === 404) {
        router.replace("/not-found"); 
      }
    }
  }, [error, router]);

  const handleReset = () => {
    try {
      setIsResetting(true);
      reset();
    } catch (err) {
    } finally {
      setIsResetting(false);
    }
  };
 
  return (
    <ErrorDisplay
      errorMessage={errorMessage}
      statusCode={statusCode}
      onReset={handleReset}
      isResetting={isResetting}
    />
  )
}